// extracted by mini-css-extract-plugin
export var csatScore = "_n1-5";
export var header = "_n1-1";
export var panelWrapper = "_n1-2";
export var postPreview = "_n1-3";
export var rightContent = "_n1-0";
export var wrappingText = "_n1-4";